import { useTranslation } from "react-i18next";
import clsx from "clsx";
import LottieSticker from "../LottieSticker";

export default function ({ className = "", style = {} }) {
    const { t } = useTranslation();

    return (
        <div
            className={clsx("flex flex-col items-center", className)}
            style={style}
        >
            <LottieSticker
                lottieName="no-result"
                className="w-[80px] h-[80px] mt-[100px]"
            />
            <div className="text-h5 font-Semibold text-text_1 mt-[12px]">
                {t("no_res")}
            </div>
        </div>
    );
}
